import {
  AllowAdminViewingAsClientRoutes,
  NotAllowedAdminViewingAsClientMethods,
} from '../constants';

export const validateAdminViewingMethod = (method: string): boolean => {
  return !NotAllowedAdminViewingAsClientMethods.includes(method.toUpperCase());
};

export const validateAdminViewingRoute = (route: string): boolean => {
  return AllowAdminViewingAsClientRoutes.some((r) => route.includes(r));
};
